import React from "react";
import { useForm } from "react-hook-form";
import PropTypes from "prop-types";
import { Col } from "../../../components/simple";

const CompanyAddUser = ({ onSubmit, companyName, errors, resetForm }) => {
  const { register, handleSubmit } = useForm();

  const onFormSubmit = data => {
    onSubmit(data);
    resetForm && resetForm();
  };

  return (
    <form onSubmit={handleSubmit(onFormSubmit)} className="row">
      <Col xs={12}>
        <h6>Invite User to company {companyName}</h6>
        <input
          type="email"
          {...register("email", { required: true })}
          className="form-control"
        />
        {errors.email && (
          <div className="text-danger">{errors?.email?.message}</div>
        )}
        <input type="submit" className="btn btn-success mt-3" />
      </Col>
    </form>
  );
};

CompanyAddUser.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  companyName: PropTypes.string,
  resetForm: PropTypes.func,
  errors: PropTypes.shape({
    email: PropTypes.shape({
      message: PropTypes.string
    })
  })
};

CompanyAddUser.defaultProps = {
  companyName: "",
  errors: null,
  resetForm: undefined
};

export default CompanyAddUser;
